import { renderNetworkTagNodes } from '@Compute/utils/secgroupDisplay'
import { HYPERVISORS_MAP } from '@/constants'
import BrandIcon from '@/sections/BrandIcon'
import i18n from '@/locales'
import { getServerConf } from '../utils'

/** 虚拟机（server）工单资源详情展示 */
export default {
  methods: {
    initServerInfo () {
      const serverInfo = [
        {
          title: i18n.t('common_385'),
          items: [
            {
              field: 'name',
              title: i18n.t('common_186'),
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                return serverConf.generate_name
              },
            },
            {
              field: 'resource_type',
              title: i18n.t('common.resource_type'),
              formatter: ({ row }) => {
                const resourceType = this.getResourceType(row) || 'server'
                return i18n.te(`dictionary.${resourceType}`) ? i18n.t(`dictionary.${resourceType}`) : resourceType
              },
            },
            {
              field: 'project',
              title: i18n.t('table.title.owner_project'),
              formatter: () => {
                const v = this.variables
                const domain = v.project_domain
                const project = v.project_name || v.project
                if (!project) return '-'
                return `${domain}/${project}`
              },
            },
            {
              field: 'region',
              title: i18n.t('common_282'),
              formatter: ({ row }) => this.formatRegionZone(row),
            },
            {
              field: 'hypervisor',
              title: i18n.t('common_283'),
              slots: {
                default: ({ row }) => {
                  const serverConf = getServerConf(row)
                  let hypervisor = serverConf.hypervisor
                  if (serverConf.extraData?.formType === 'private' && hypervisor === 'kvm') {
                    hypervisor = 'cloudpods'
                  }
                  if (!hypervisor) return '-'
                  const brand = HYPERVISORS_MAP[hypervisor] && HYPERVISORS_MAP[hypervisor].brand
                  if (!brand) return '-'
                  return [<BrandIcon name={brand} />]
                },
              },
            },
            {
              field: 'config',
              title: i18n.t('common_428'),
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                const cpu = serverConf.vcpu_count || (row.skuInfo && row.skuInfo.cpu_core_count)
                const memory = serverConf.vmem_size || (row.skuInfo && row.skuInfo.memory_size_mb)
                let ret = (cpu || '-') + i18n.t('common_429') + ((memory / 1024) || '-') + 'GB'
                if (row.skuInfo && row.skuInfo.instance_type_category) {
                  const type = this.getI18NValue(`skuCategoryOptions['${this.detailsData.hypervisor}']['${row.skuInfo.instance_type_category}']`, row.skuInfo.instance_type_category)
                  ret += `（${row.skuInfo.name || ''} ${type}）`
                }
                return ret
              },
            },
            {
              field: 'count',
              title: i18n.t('common_430'),
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                return (serverConf.__count__ || 1) + i18n.t('common_431')
              },
            },
            {
              field: 'image',
              title: this.$t('compute.text_96'),
              formatter: ({ row }) => row.imageInfo?.name || '-',
            },
            {
              field: 'os_arch',
              title: 'OS_ARCH',
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                return serverConf.os_arch || row.os_arch || '-'
              },
            },
            {
              field: 'sysdisks',
              title: i18n.t('common_432'),
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                return this.getDiskInfo(row, serverConf).sysDisk || '-'
              },
            },
            {
              field: 'disks',
              title: i18n.t('common_433'),
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                return this.getDiskInfo(row, serverConf).dataDisk || '-'
              },
            },
            {
              field: 'user',
              title: this.$t('compute.text_1372'),
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                if (serverConf.keypair) {
                  return `root (${this.$t('compute.text_33')}: ${row.keypairInfo?.name ? `${row.keypairInfo.name}` : '-'})`
                }
                if (Object.prototype.hasOwnProperty.call(serverConf, 'reset_password') && !serverConf.reset_password) {
                  return `root (${this.$t('compute.text_164')}${this.$t('compute.text_34')})`
                }
                if (serverConf.password) {
                  return `root (${this.$t('compute.text_164')}${this.$t('compute.text_35')})`
                }
                return `root (${this.$t('compute.text_164')}${this.$t('compute.text_32')})`
              },
            },
            {
              field: 'cdrom',
              title: 'ISO',
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                const cdrom = serverConf.cdrom
                if (!cdrom) return '-'
                if (row.isoInfo && row.isoInfo.name) return row.isoInfo.name
                const idx = cdrom.indexOf('(')
                return idx > -1 ? cdrom.substring(0, idx) : cdrom
              },
            },
            {
              field: 'isolated_devices',
              title: 'GPU',
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                if (!serverConf.isolated_devices) return '-'
                const gpuArr = serverConf.isolated_devices
                const gpu = {}
                gpuArr.forEach((item) => {
                  const key = `${item.vendor}/${item.model}`
                  gpu[key] = (gpu[key] || 0) + 1
                })
                let str = ''
                for (const k in gpu) {
                  str += i18n.t('common_434', [gpu[k], k])
                }
                return str.slice(1) || '-'
              },
            },
            {
              field: 'network',
              title: i18n.t('compute.text_104'),
              slots: {
                default: () => this.renderWorkflowNetworkInfo(),
              },
            },
            {
              field: 'hostname',
              title: i18n.t('common_388'),
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                return serverConf.hostname || row.hostname || '-'
              },
            },
            {
              field: 'eip',
              title: this.$t('compute.text_1374'),
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                if (serverConf.eip) return serverConf.eip
                if (serverConf.eip_charge_type) {
                  return `${this.$t('compute.text_1375')}: ${serverConf.eip_bgp_type ? (this.$te(`bgpTypes.${serverConf.eip_bgp_type}`) ? this.$t(`bgpTypes.${serverConf.eip_bgp_type}`) : serverConf.eip_bgp_type) : ''} ${this.$te(`chargeTypes.${serverConf.eip_charge_type}`) ? this.$t(`chargeTypes.${serverConf.eip_charge_type}`) : serverConf.eip_charge_type} ${serverConf.eip_bw} Mbps`
                }
                if (serverConf.public_ip_charge_type) {
                  return `${this.$t('compute.text_1375')}: ${serverConf.eip_bgp_type ? (this.$te(`bgpTypes.${serverConf.eip_bgp_type}`) ? this.$t(`bgpTypes.${serverConf.eip_bgp_type}`) : serverConf.eip_bgp_type) : ''} ${this.$te(`chargeTypes.${serverConf.public_ip_charge_type}`) ? this.$t(`chargeTypes.${serverConf.public_ip_charge_type}`) : serverConf.public_ip_charge_type} ${serverConf.public_ip_bw} Mbps`
                }
                return '-'
              },
            },
            {
              field: 'secgroups',
              title: i18n.t('compute.text_105'),
              slots: {
                default: ({ row }) => {
                  if (row.networkTags && row.networkTags.length) {
                    return renderNetworkTagNodes(row.networkTags)
                  }
                  const ret = []
                  if (row.secgroupInfo && row.secgroupInfo.data && row.secgroupInfo.data.length) {
                    row.secgroupInfo.data.forEach(item => {
                      ret.push(<div>{item.name}</div>)
                    })
                  }
                  return ret.length ? ret : '-'
                },
              },
            },
            {
              field: 'schedtags',
              title: i18n.t('compute.text_311'),
              slots: {
                default: ({ row }) => {
                  const serverConf = getServerConf(row)
                  if (serverConf.prefer_host) {
                    return `${this.$t('compute.text_14')}: ${row.hostInfo?.name || serverConf.prefer_host}`
                  }
                  if (serverConf.schedtags && row.schedtagInfo) {
                    const ret = [<div>{this.$t('compute.text_3')}</div>]
                    ret.push(...row.schedtagInfo.map(item => {
                      return <div>{item.schedtagObj?.name}{item.strategy ? ` ${this.$te(`schedtagPolicys.${item.strategy}`) ? this.$t(`schedtagPolicys.${item.strategy}`) : item.strategy}` : ''}</div>
                    }))
                    return ret
                  }
                  return '-'
                },
              },
            },
            {
              field: 'bios',
              title: this.$t('compute.text_1155'),
              formatter: ({ row }) => getServerConf(row).bios || '-',
            },
            {
              field: 'bastion_server',
              title: this.$t('compute.text_1156'),
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                return row.backupHostInfo?.name || serverConf.prefer_backup_host || '-'
              },
            },
            {
              field: 'groups',
              title: this.$t('dictionary.instancegroup'),
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                return row.groupInfo?.map(item => item.name).join(',') || serverConf.groups || '-'
              },
            },
            {
              field: 'encrypt_key',
              title: this.$t('compute.server.encryption'),
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                if (serverConf.encrypt_key_new) {
                  return `${this.$t('compute.text_202')} ${serverConf.encrypt_key_alg || ''}`
                }
                return row.encryptKeyInfo?.name || serverConf.encrypt_key_id || '-'
              },
            },
            {
              field: 'duration',
              title: i18n.t('common_435'),
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                const durationUnit = {
                  h: i18n.t('common_11'),
                  w: i18n.t('common_417'),
                  d: i18n.t('common_12'),
                  m: i18n.t('common_13'),
                  y: i18n.t('common_14'),
                }
                if (serverConf.duration) {
                  const duration = parseInt(serverConf.duration)
                  const unit = serverConf.duration.substr(-1)
                  return i18n.t('common_436', [duration, durationUnit[unit.toLowerCase()]])
                }
                return '-'
              },
            },
          ],
        },
      ]
      this.extraInfo.push(...serverInfo)
    },
  },
}
